import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { Enums } from '../../shared/models/enums';
import { ModalService } from '../../shared/services/modal.service';
import { CellRendererElementSubTypes } from '../../shared/widgets/data-grid/enums/cell-renderer-element-Subtype.enum';
import { CellRendererElementTypes } from '../../shared/widgets/data-grid/enums/cell-renderer-element.enum';
import { CellRendererTypes } from '../../shared/widgets/data-grid/enums/cell-renderer.enum';
import { FilterTypes } from '../../shared/widgets/data-grid/enums/filter-types.enum';
import { TableColumn } from '../../shared/widgets/data-grid/interfaces/table-column.interface';

@Injectable({
    providedIn: 'root'
})export class HomeInspectorDashboardGridService {
    modalRef: MDBModalRef;
    confirmationStatus = Enums.confirmationStatus;
    constructor(private modalService: ModalService) { }


    fileNameCellRenderer(rowData) {
        return rowData.unreadNotification ? `<span class="grid-cell-notification me-1"><i class="fas fa-circle text-buttercup"></i></span>` : '';
    }

    savingsCellRenderer(rowData, field) {
        if (rowData[field]) {
            const percent = parseFloat(rowData[field].replace('%', ''));
            if (!Number.isNaN(percent) && percent >= 20) {
                return `<div class="text-green text-truncate" title="` + rowData[field] + `">` + rowData[field] + `</div>`;
            } else {
                return rowData[field];
            }
        } else {
            return '';
        }
    };

    dateCellRenderer(rowData, field) {
        if (rowData[field]) {
            const value = formatDate(rowData[field], 'yyyy-MM-dd hh:mm a', 'en-US');
            return `<div class="text-truncate" title="` + value + `">` + value + `</div>`;
        } else {
            return '';
        }
    }

    fixedTo2Decimal(rowData, field) {
        if (rowData[field]) {
            const value = parseFloat(rowData[field]);
            return (!Number.isNaN(value)) ? `<div class="text-truncate" title="` + value.toFixed(2) + `">` + value.toFixed(2) + `</div>` : rowData[field];
        } else {
            return '';
        }

    }

    businessTargetCellRenderer(rowData, field) {
        const value = rowData[field];
        if (value !== null) {
            return rowData[field].toLocaleString();
        } else {
            return '';
        }
    }
    colsSA: Array<TableColumn> = [
        {
            field: 'projectNumber',
            header: 'Project Number',
            translationKey: 'ProjNo',
            sortName: 'projectNumber',
            sort: true,
            pinned: true,
            filter: { type: FilterTypes.text }
        },
        {
            field: 'projectName',
            header: 'Project Name',
            translationKey: 'ProjName',
            sort: true,
            pinned: true,
            sortName: 'projectName',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onSubprojectNameclick'
            }
        },
        {
            field: 'projectStatus',
            header: 'Project Status',
            translationKey: 'ProjectStatus',
            sort: true,
            sortName: 'ProjectStatus',
            pinned: true,
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Created', value: 'Created' },
                    { label: 'Sent for Certification', value: 'Sent for Certification' },
                    { label: 'Certified', value: 'Certified' },
                    { label: 'Ready for Audit', value: 'Ready for Audit' },
                    { label: 'Ready for Certification', value: 'Ready for Certification' },
                    { label: 'Project Under Audit', value: 'Project Under Audit' },

                    { label: 'Certifier Feedback', value: 'Certifier Feedback' },
                    { label: 'Certificate Issued', value: 'Certificate Issued' }
                ]
            }
        },
        {
            field: 'versionNumber',
            header: 'Version Number',
            translationKey: 'VersionNumber',
            sort: true,
            pinned: false,
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'V 1.0', value: 'v1.0.0' },
                    { label: 'V 1.1', value: 'v1.1.0' },
                    { label: 'V 2.0', value: 'v2.0.0' }
                ]
            },
            sortName: 'versionNumber'
        },
        {
            field: 'homeInspectorEmail',

            header: 'Home Inspector Email',
            pinned: false,
            sort: true,
            sortName: 'homeInspectorEmail',
            filter: { type: FilterTypes.text },

        },
        {
            field: 'homeInspectorName',
            header: 'Home Inspector Name',
            sort: true,
            sortName: 'homeInspectorName',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'auditorName',
            header: 'Auditor Name',
            sortName: 'auditorName',
            sort: true,
            pinned: false,
            filter: { type: FilterTypes.text }
        },
        {
            field: 'batchIdentifier',
            header: 'Batch Identifier ',
            pinned: false,
            sortName: 'batchIdentifier',
            sort: true,
            filter: { type: FilterTypes.text }

        },
        {
            field: 'rejectionCount',
            header: 'Return Count',
            sortName: 'rejectionCount',
            pinned: false,
            sort: true,
            filter: { type: FilterTypes.text }
        },
        {
            field: 'certificationCycle',
            header: 'Certification Cycle ',
            sortName: 'certificationCycle',
            pinned: false,
            sort: true,
            filter: { type: FilterTypes.text }
        },
        {
            field: 'latestCertifierAction',
            header: 'Latest Certifier Action ',
            pinned: false,
            sort: false,
            filter: { type: FilterTypes.text }
        },
        {
            field: 'country',
            header: 'Country',
            translationKey: 'Country',
            sort: true,
            pinned: false,
            sortName: 'Country',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'city',
            header: 'City',
            sort: true,
            pinned: false,
            translationKey: 'StaticCity',
            sortName: 'city',
            filter: { type: FilterTypes.text }

        },
        {
            field: 'loanNumber',
            header: 'Loan Reference Number',
            //translationKey: 'LoanNo',
            sortName: 'LoanNo',
            sort: false,
            pinned: false,
            filter: { type: FilterTypes.text }
        },
        {
            field: 'organizationName',
            header: 'Organization Name',
            translationKey: 'OrgName',
            sort: true,
            pinned: false,
            sortName: 'OrganizationName',
        filter: { type: FilterTypes.text }
        },
        {
            field: 'totalFloorArea',
            header: 'Total Floor Area(m2)',
            translationKey: 'TotalFloorArea',
            filter: { type: FilterTypes.text },
            sort: true,
            sortName: 'TotalFloorArea',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
            {
            field: 'energySavings',
            header: 'Energy Savings (MWh/Year)',
            translationKey: 'EnergySavings',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'waterSavings',
            header: 'Water Savings (m3/Year)',
            translationKey: 'WaterSavings',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'cO2Savings',
            header: 'CO2 Savings (tCO2/Year)',
            translationKey: 'CO2Savings',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
          field: 'energySavings',
            header: 'Energy Savings (MWh/Year)',
            translationKey: 'EnergySavings',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
         {
            field: 'waterSavings',
            header: 'Water Savings (m3/Year)',
            translationKey: 'WaterSavings',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
         {
            field: 'cO2Savings',
            header: 'CO2 Savings (tCO2/Year)',
            translationKey: 'CO2Savings',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.fixedTo2Decimal
            }
        },
        {
            field: 'yearOfConstruction',
            header: 'Expected Construction Completion',
            translationKey: 'yearOfConstruction',
            sort: false,
            pinned: false,
            sortName: 'yearOfConstruction',
            //filter: { type: FilterTypes.text }
        },
        {
            field: 'projectCreatedDate',
            header: 'Project Created Date',
            translationKey: 'ProjectCreatedDate',
            sort: true,
            pinned: false,
            sortName: 'ProjectCreatedDate',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'submittedDateForAudit',
            header: 'Submission Date for Audit',
            translationKey: 'submittedDateForAudit',
            sort: true,
            pinned: false,
            sortName: 'submittedDateForAudit',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'projectSentForCertificationDate',
            header: 'Sent for Certification Approval Date ',
            translationKey: 'ProjectSentForCertificationCreatedDate',
            sort: true,
            pinned: false,
            sortName: 'ProjectSentForCertificationCreatedDate',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'projectCertifiedDate',
            header: 'Certification Approved Date ',
            translationKey: 'ProjectCertifiedDate',
            sort: true,
            pinned: false,
            sortName: 'ProjectCertifiedDate',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'projectCertificateIssueDate',
            header: 'Certificate Issued Date',
            translationKey: 'ProjectCertificateIssueDate',
            sort: true,
            pinned: false,
            sortName: 'ProjectCertificateIssueDate',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'certifierName',
            header: 'Certifier Name',
            sort: true,
            sortName: 'certifierName',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'lastActivity',
            header: 'Last Activity',
            translationKey: 'LastActive',
            sort: true,
            pinned: false,
            sortName: 'lastActivity',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'downloadCertificate',
            header: 'Download Home Prescriptive Certificate',
            displayName: ' ',
            isEnable: 'downloadCertificate',
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onDownloadHomeInspectionCertificate',
                elementsubType: CellRendererElementSubTypes.download,
            }
        },
        {
            field: 'canDelete',
            header: 'Delete',
            isEnable: 'canDelete',
            displayName: ' ',
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onDeleteHomeInspectionProjects',
                elementsubType: CellRendererElementSubTypes.delete,
            }
        }

    ];
}